var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricGenerator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 15h54a2 2 0 0 1 2 2v34a0 0 0 0 1 0 0h-58a0 0 0 0 1 0 0v-34a2 2 0 0 1 2-2z",
    fill: "#5ac6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 51h58v6h-58z",
    fill: "#394d5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 57h10v4h-10z",
    fill: "#7d8d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 57h10v4h-10z",
    fill: "#7d8d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 19h16v32h-16z",
    fill: "#72edc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 23h8v8h-8z",
    fill: "#f4f4e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 19h6v32h-6z",
    fill: "#388e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 19h20v32h-20z",
    fill: "#72edc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 22h4v4h-4z",
    fill: "#388e75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 42h4v4h-4z",
    fill: "#388e75"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fcf05a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43 23h5l-3 5h5l-7 9v-5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 34h10v2h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 38h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 38h4v2h-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50 48h-3v-2h2v-5h2v6a1 1 0 0 1 -1 1z",
    fill: "#f4f4e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 46h2v2h-2z",
    fill: "#f4f4e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 46h2v2h-2z",
    fill: "#f4f4e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 7h18v4h-18z",
    fill: "#7d8d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 11h4v4h-4z",
    fill: "#394d5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 11h4v4h-4z",
    fill: "#394d5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 10h-2v-2h2a1 1 0 0 0 1-1v-5h2v5a3 3 0 0 1 -3 3z",
    fill: "#32b1cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricGenerator);
export default __webpack_public_path__ + "static/media/electric-generator.b26f8d75115cdda12eaf7be9a0186f45.svg";
export { ForwardRef as ReactComponent };